export default "__VITE_PUBLIC_ASSET__53c659c8__"